import { Component, OnInit, OnDestroy } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { SupportChatFacade } from '@state/support-chat';
import { ReplaySubject, take } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { SupportChatWindowDesktopDrawerService } from '@shared/support-chat-window/support-chat-window-desktop-drawer/support-chat-window-desktop-drawer.service';
import { environment } from '@environment';
import { ROLES_KEYS } from '@interfaces';

@Component({
  selector: 'app-chats-wrapper-desktop',
  templateUrl: './chats-wrapper-desktop.component.html',
  styleUrls: ['./chats-wrapper-desktop.component.scss'],
  animations: [
    trigger('showChatsPanel', [
      state(
        'false',
        style({
          transform: 'translateX(1px)',
        })
      ),
      state(
        'true',
        style({
          transform: 'translateX(-401px)',
        })
      ),
      transition('true <=> false', animate('400ms ease-in-out')),
    ]),
    trigger('nextToPanel', [
      state(
        'false',
        style({
          transform: 'translateX(400px)',
        })
      ),
      state(
        'true',
        style({
          transform: 'translateX(0)',
        })
      ),
      transition('true <=> false', animate('400ms ease-in-out')),
    ]),
  ],
})
export class ChatsWrapperDesktopComponent implements OnInit, OnDestroy {
  private destroy$: ReplaySubject<boolean> = new ReplaySubject(1);

  public API_URL = environment.API_URL;

  public isMinimized = this.supportChatFacade.isMinimized$;

  public showChatsListPanel = false;

  public currentSearchType: ROLES_KEYS.Foreigner | ROLES_KEYS.Employer = ROLES_KEYS.Foreigner;

  public openSupportChat$ = this.supportChatFacade.openSupportChat$;
  public unreadCount$ = this.supportChatFacade.myUnreadCount$;
  public unreadMessagesCount$ = this.supportChatFacade.myUnreadMessagesCount$;

  constructor(
    private readonly supportChatFacade: SupportChatFacade,
    private readonly supportChatWindowDesktopDrawerService: SupportChatWindowDesktopDrawerService
  ) {}

  public ngOnInit(): void {
    this.supportChatFacade.getMyUnreadCount();

    this.openSupportChat$
      .pipe(
        filter(chat => !!chat?.supportChat?.id),
        takeUntil(this.destroy$)
      )
      .subscribe(chat => {
        this.supportChatWindowDesktopDrawerService.open(chat.supportChat.id, this.currentSearchType);
      });

    this.supportChatWindowDesktopDrawerService.chatListPanelOpened$.pipe(takeUntil(this.destroy$)).subscribe(value => {
      this.showChatsListPanel = value;
    });

    this.supportChatWindowDesktopDrawerService.updateChatsListPanelState(this.showChatsListPanel);
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public toggleChatsPanel(): void {
    this.supportChatWindowDesktopDrawerService.chatListPanelOpened$
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe(value => {
        this.supportChatWindowDesktopDrawerService.updateChatsListPanelState(!value);
      });
  }

  public toggleChatsPanelMinimize(): void {
    this.supportChatFacade.setMinimizedStatus(false);
  }

  public onSearchTypeChange(type: ROLES_KEYS.Foreigner | ROLES_KEYS.Employer): void {
    this.currentSearchType = type;
  }
}
